module.exports = __webpack_public_path__ + "img/instagram_wave_music.1d758380.png";